import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { RefreshCw, X } from 'lucide-react';
import { usePWA } from '@/hooks/usePWA';
import { useBreakpoint } from '@/hooks/useMediaQuery';
import { cn } from '@/lib/utils';

export function PWAUpdatePrompt() {
  const { needRefresh, refreshApp } = usePWA();
  const { isMobile } = useBreakpoint();
  const [dismissed, setDismissed] = useState(false);

  if (!needRefresh || dismissed) {
    return null;
  }

  const handleRefresh = () => {
    refreshApp();
  };

  const handleDismiss = () => {
    setDismissed(true);
  };

  return (
    <div className={cn(
      'fixed z-50 p-4',
      isMobile ? 'top-0 left-0 right-0' : 'top-4 right-4 max-w-sm'
    )}>
      <Card className="shadow-lg border-2 border-blue-200 bg-blue-50">
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <RefreshCw className="h-5 w-5 text-blue-600" />
              <CardTitle className="text-sm text-blue-900">Update Available</CardTitle>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleDismiss}
              className="h-6 w-6 p-0 text-blue-600 hover:text-blue-800"
            >
              <X className="h-3 w-3" />
            </Button>
          </div>
          <CardDescription className="text-xs text-blue-700">
            A new version of the app is available. Refresh to get the latest features and improvements.
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-0">
          <div className="flex gap-2">
            <Button
              onClick={handleRefresh}
              size="sm"
              className="flex-1 gap-2 bg-blue-600 hover:bg-blue-700"
            >
              <RefreshCw className="h-3 w-3" />
              Refresh
            </Button>
            <Button
              onClick={handleDismiss}
              variant="outline"
              size="sm"
              className="flex-1 border-blue-300 text-blue-700 hover:bg-blue-100"
            >
              Later
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}